const colors = {
  main: '#191919', // Color negro oscuro (Textos)
  primary: '#f95752',
  secondary: '#f59a1d',

  dark: '#000000', // Negro
  light: '#ffffff', // blanco

  // GRISES
  grayDarkest: '#191919',
  graySad: '#313030',
  grayDarker: '#444444',
  grayDark: ' #4c4c4c',
  gray: ' #898989',
  grayLight: '#d0d0d0',
  grayMoreLight: '#fbfbfb',
  grayLighter: ' #e7e7e7',
  grayLightest: '#f3f3f3',

  // Avisos y errores
  success: '#87c139', // Verde
  error: '#e71d02', // Rojo
  pending: '#fce2c3', // Ambar
  warning: '#fcc400',
  info: '#f59a1d',

  // Más colores
  colorOne: '#60c9de',
  colorTwo: '#fcc400',
  colorThree: '#3cc8c1',
  colorOneDark: '#489fb4',
  colorFour: '#d693c8',
  colorFive: '#dbf1bb',
  colorSix: '#c580b7',
  activeBlue: '#dbf1bb',
  blueLinkedin: '#256da8',
  lightLinkedin: '#597BBB',
  colorPlata: '#fae3ed',

  // Colores secondary
  secondaryLightest: '#c8cee0'
};

export default colors;
